import Api from "../config/api";

export const findAllProcedimentoOdontologicoSujeitoAtencao = async (
  variables
) => {
  const response = await Api.post("", {
    query: `
    query ($orcado: Boolean, $sujeitoAtencaoId: UUID, $procedimentoRealizado: Boolean, $status: [ProcedimentoOdontologicoStatus], $pageableDTO: PageableDTOInput) {
    findAllProcedimentoOdontologico(orcado: $orcado, sujeitoAtencaoId: $sujeitoAtencaoId, procedimentoRealizado: $procedimentoRealizado, status: $status, pageableDTO: $pageableDTO) {
      id
      valor
      status
      dataHoraFinalizacao
      executante {
        nome
      }
      orcamentoAtual {
        id
        numero
        tipo
        faturado
        profissionalExecutante {
          id
          nome
        }
        orcamentoProcedimentos {
          id
          procedimentoOdontologico {
            id
          }
          valorUnitario
          valorComDesconto
        }
        agendamento {
        data
        assinaturaPresenca
        profissionalSaude {
          id
          nome
        }
      }
      }
      agendamento {
        data
        assinaturaPresenca
        profissionalSaude {
          id
          nome
        }
      }
      procedimento {
        nome
      }
      procedimentoRealizado {
        profissionalSaude {
          nome
        }
      }
    }
  }`,
    variables,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }

  return response.data.data.findAllProcedimentoOdontologico;
};

export const findOrcamentoById = async (orcamentoId) => {
  const response = await Api.post("", {
    query: `
    query ($orcamentoId: UUID) {
      findOrcamentoById(orcamentoId: $orcamentoId) {
        id
        numero
        observacao
        faturado
        dataHoraLancamento
        tipo
        statusOrcamentoOdontologico {
          nome
          id
          tipo
        }
        convenio {
          descricao
          id
        }
        procedimentosOdontologicos {
          procedimento {
            nome
          }
          dente {
            codigo
          }
          face
          mucosaOral {
            descricao
          }
          status
        }
      }
    }`,
    variables: { orcamentoId },
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }

  return response.data.data.findOrcamentoById;
};

export const updateStatusProcedimento = async (variables) => {
  const response = await Api.post("", {
    query: `mutation UpdateStatusProcedimentoOdontologico($procedimentosOdontologicoId: [UUID], $status: ProcedimentoOdontologicoStatus, $motivo: String) {
    updateStatusProcedimentoOdontologico(procedimentosOdontologicoId: $procedimentosOdontologicoId, status: $status, motivo: $motivo)
  }`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data.updateStatusProcedimentoOdontologico;
};

export const findAllAgendamentoByProcedimentoOdontologico = async (
  variables
) => {
  const response = await Api.post("", {
    query: `query ($orcamentoId: UUID, $procedimentoOdontologicoId: UUID) {
      findAllAgendamentoByProcedimentoOdontologico(orcamentoId: $orcamentoId, procedimentoOdontologicoId: $procedimentoOdontologicoId) {
        data
        horaFormatada
        situacao
        profissionalSaude {
          nome
        }
      }
    }`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data.findAllAgendamentoByProcedimentoOdontologico;
};

export const verificaUtilizaRepasseAutomaticoProcedimentoOrcamento = async () => {
  const response = await Api.post("", {
    query: `query {
      findByUnidadeLogadaConfiguracaoUnidade {
        utilizaRepasseAutomaticoProcedimentoOrcamento
      }
    }`
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade;
};

export const linkEmitirNotaFiscal = async(variables) => {
  const response = await Api.post("", {
    query: `query($profissionalSaudeId: Long, $gerarNota: Boolean, $orcamentoProcedimentoId: UUID, $dataCompetencia: LocalDate) {
    linkNotaFiscal(profissionalSaudeId: $profissionalSaudeId, gerarNota: $gerarNota, orcamentoProcedimentoId: $orcamentoProcedimentoId, dataCompetencia: $dataCompetencia)
    }`,
    variables
  });

  if (response.data.errors) {
    throw response.data.errors[0].message;
  }
  
  return response.data.data.linkNotaFiscal;
};

export const verificaPossuiNotaFiscal = async(variables) => {
  const response = await Api.post("", {
    query: `query ($orcamentoProcedimentoId: UUID) {
      verificacaoProcedimentoNFSe(orcamentoProcedimentoId: $orcamentoProcedimentoId)
    }`,
    variables
  });

  if(response?.data?.data) {
      return response.data.data.verificacaoProcedimentoNFSe;
  } else {
      throw(new Error(response.data.errors[0]))
  }
};